import { useState, type FormEvent } from 'react'

export function ContactForm() {
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle')
  const [reference, setReference] = useState('')
  const [message, setMessage] = useState('')

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setStatus('sending')
    const form = new FormData(event.currentTarget)
    const payload = Object.fromEntries(form.entries())

    try {
      const request = await fetch('/api/request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ requestType: 'contact', ...payload }),
      })
      const response = (await request.json()) as { ok: boolean; reference?: string; message?: string }
      setMessage(response.message || '')
      if (request.ok && response.ok) {
        setReference(response.reference || '')
        setStatus('sent')
        event.currentTarget.reset()
      } else {
        setStatus('error')
      }
    } catch {
      setMessage('Your message could not be sent. Please try again in a moment.')
      setStatus('error')
    }
  }

  if (status === 'sent') {
    return (
      <div className="request-confirmation" role="status">
        <span className="status-mark" aria-hidden="true">✓</span>
        <h2>Message received</h2>
        <p>{message}</p>
        <p className="reference">Reference: <strong>{reference}</strong></p>
      </div>
    )
  }

  return (
    <form className="contact-form" onSubmit={submit}>
      <div className="form-grid two-columns">
        <label>Name <span aria-hidden="true">*</span><input name="name" required autoComplete="name" maxLength={120} /></label>
        <label>Email <span aria-hidden="true">*</span><input name="email" type="email" required autoComplete="email" maxLength={160} /></label>
        <label>Phone <input name="phone" type="tel" autoComplete="tel" maxLength={30} /></label>
        <label>Subject <span aria-hidden="true">*</span><input name="subject" required maxLength={160} /></label>
      </div>
      <label>Message <span aria-hidden="true">*</span><textarea name="message" required rows={6} maxLength={2000} /></label>
      <div className="honeypot" aria-hidden="true"><label>Website<input name="website" tabIndex={-1} autoComplete="off" /></label></div>
      <div className="privacy-callout"><strong>Please keep sensitive information out of this form.</strong><p>Do not send identification images, Social Security numbers, banking data, medical records, or confidential documents.</p></div>
      {status === 'error' && <div className="form-error" role="alert"><strong>Message not sent.</strong><p>{message}</p></div>}
      <button className="button" type="submit" disabled={status === 'sending'}>{status === 'sending' ? 'Sending…' : 'Send message'}</button>
    </form>
  )
}
